import type { AsyncState } from '@essent/common';
import type { LicensePlateLookupResponse } from '@integration/api-client/smart-charging';

export const smartChargingStoreSelectorKey = 'smart-charging';

export type SmartChargingState = {
  licensePlateLookup: AsyncState<LicensePlateLookupResponse>;
};
